const styles = (theme) => ({
  tracksContent: {
    backgroundColor: "#ffffff",
    borderRadius: "10px",
    padding: "10px",
  },
  responsive: {
    width: "60px",
    height: "60px",
  },
  textTime: {
    fontWeight: "bold !important",
  }
});

export default styles;
